import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-action-bar" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "coverSetting" }
const _hoisted_5 = { class: "coverSetting_left" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "form-row geolocation-row" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-row triple-row" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = { class: "form-row triple-row" }
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "rate-wrapper" }
const _hoisted_16 = { class: "media-setting-section" }
const _hoisted_17 = { class: "media-item-box" }
const _hoisted_18 = { class: "media-item-info" }
const _hoisted_19 = { class: "label-text" }
const _hoisted_20 = { class: "upload-area-wrapper" }
const _hoisted_21 = { class: "image-slot" }
const _hoisted_22 = { class: "media-item-box column-layout" }
const _hoisted_23 = { class: "media-item-info" }
const _hoisted_24 = { class: "label-text" }
const _hoisted_25 = { class: "slideshow-container" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "coverSetting_right" }
const _hoisted_28 = { class: "mock-title" }
const _hoisted_29 = { class: "animate__animated animate__fadeIn app-mockup" }
const _hoisted_30 = { class: "phone-shell" }
const _hoisted_31 = { class: "phone-screen" }
const _hoisted_32 = { class: "app_icon" }
const _hoisted_33 = { class: "back-circle" }
const _hoisted_34 = { class: "more-circle" }
const _hoisted_35 = { class: "app_cover" }
const _hoisted_36 = { class: "author_info" }
const _hoisted_37 = { class: "mock-game-title" }
const _hoisted_38 = { class: "mock-author" }
const _hoisted_39 = { class: "about" }
const _hoisted_40 = { class: "section-sub-title" }
const _hoisted_41 = { class: "spec-list" }
const _hoisted_42 = { class: "spec-item" }
const _hoisted_43 = { class: "spec-label" }
const _hoisted_44 = { class: "spec-item" }
const _hoisted_45 = { class: "spec-label" }
const _hoisted_46 = { class: "spec-val" }
const _hoisted_47 = { class: "spec-item" }
const _hoisted_48 = { class: "spec-label" }
const _hoisted_49 = { class: "spec-val" }
const _hoisted_50 = { class: "introduce" }
const _hoisted_51 = { class: "section-sub-title" }
const _hoisted_52 = { class: "introduce-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_More = _resolveComponent("More")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_Location = _resolveComponent("Location")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("edit.cover.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          onClick: _ctx.handleSave,
          class: "save-top-btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("edit.cover.save")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          "label-position": "top",
          class: "clean-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.gameTitle'),
                class: "flex-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.gameTitle,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.gameTitle) = $event)),
                    placeholder: "请输入游戏标题",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: "游戏创作者",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.author,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.author) = $event)),
                    placeholder: "作者名称",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.opening_hours')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.openHour,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.openHour) = $event)),
                    placeholder: "例如: 09:00 - 18:00",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.experience_time')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.experienceTime,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.experienceTime) = $event)),
                    placeholder: "例如: 周二至周日",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.begin'),
                class: "flex-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.beginPoint,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.beginPoint) = $event)),
                    placeholder: "起点位置描述",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: "经度 (Log)",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.log,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.log) = $event)),
                    placeholder: "经度",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "纬度 (Lat)",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.lat,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.lat) = $event)),
                    placeholder: "纬度",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_form_item, {
                label: "精确地点名称",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.placeName,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.placeName) = $event)),
                    placeholder: "具体定位场所名称",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.end'),
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.endPoint,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.endPoint) = $event)),
                    placeholder: "终点位置描述",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.walking_distance')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.walk,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.walk) = $event)),
                    placeholder: "公里数",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.estimated_time')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.estimateTime,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.estimateTime) = $event)),
                    placeholder: "预计时间",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.player_age')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.playerAge,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.playerAge) = $event)),
                    placeholder: "适用年龄",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.Facilities_along_way')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.along,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.along) = $event)),
                    placeholder: "沿途洗手间、便利店等设施说明",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.transportation')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.transportation,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.transportation) = $event)),
                    placeholder: "推荐交通工具",
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.address')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.merchantAddress,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.merchantAddress) = $event)),
                  placeholder: "请输入完整详细地址",
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.area')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_cascader, {
                    placeholder: "请选择地区",
                    style: {"width":"100%"},
                    modelValue: _ctx.form.region,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.region) = $event)),
                    options: _ctx.selectRegion,
                    size: "large",
                    onChange: _ctx.handleChange
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.gameLanguage')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.gameLanguage,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.gameLanguage) = $event)),
                    size: "large",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "繁体中文",
                        value: "繁体中文"
                      }),
                      _createVNode(_component_el_option, {
                        label: "简体中文",
                        value: "简体中文"
                      }),
                      _createVNode(_component_el_option, {
                        label: "English",
                        value: "English"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.gameCategory')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.gameClass,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.gameClass) = $event)),
                    size: "large",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "单人角色剧本",
                        value: "单人角色剧本"
                      }),
                      _createVNode(_component_el_option, {
                        label: "多人角色剧本",
                        value: "多人角色剧本"
                      }),
                      _createVNode(_component_el_option, {
                        label: "亲子互动",
                        value: "亲子互动"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                label: "游戏分类",
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.gameCategory,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.gameCategory) = $event)),
                    size: "large",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "博物馆",
                        value: "博物馆"
                      }),
                      _createVNode(_component_el_option, {
                        label: "城市探索",
                        value: "城市探索"
                      }),
                      _createVNode(_component_el_option, {
                        label: "线上解密",
                        value: "线上解密"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.tag'),
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.tips,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.tips) = $event)),
                    multiple: "",
                    filterable: "",
                    "allow-create": "",
                    "multiple-limit": "5",
                    "default-first-option": "",
                    placeholder: "请选择或输入自定义标签",
                    size: "large",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.difficulty'),
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_rate, {
                      modelValue: _ctx.form.difficulty,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.playTime'),
                class: "flex-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.form.playTime,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.playTime) = $event)),
                    min: 10,
                    max: 120,
                    step: 10,
                    size: "large",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_16, [
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "media-title" }, "多媒体资源配置", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("edit.cover.gameCover")), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "desc-text" }, " 游戏在列表展示时的封面图。推荐比例 4:3，支持 JPG/PNG 格式 (5MB 内) ", -1))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: _ctx.UpdateApi,
                    "show-file-list": false,
                    "on-success": _ctx.handleAvatarSuccess,
                    "before-upload": _ctx.beforeAvatarUpload,
                    limit: 1,
                    "file-list": _ctx.fileList,
                    disabled: _ctx.allowUpload
                  }, {
                    default: _withCtx(() => [
                      (_ctx.form.gameCover)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            src: _ctx.form.gameCover,
                            class: "avatar",
                            alt: "游戏封面",
                            fit: "cover"
                          }, {
                            error: _withCtx(() => [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icon_picture)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            class: "avatar-uploader-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"]),
                  (_ctx.allowUpload)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "danger",
                        plain: "",
                        onClick: _ctx.clearImage,
                        class: "clear-main-btn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("edit.cover.slideshow")), 1),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "desc-text" }, " App 详情页的画廊。最多上传 5 张，可拖动卡片重新排序 ", -1))
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_VueDraggable, {
                    ref: "el",
                    modelValue: _ctx.fileList2,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.fileList2) = $event)),
                    class: "slideshow-draggable"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.uid || index,
                          class: "slideshow-card"
                        }, [
                          _createVNode(_component_el_image, {
                            src: item.url,
                            fit: "cover",
                            class: "slideshow-image"
                          }, null, 8, ["src"]),
                          _createElementVNode("div", {
                            class: "slideshow-mask",
                            onClick: ($event: any) => (_ctx.clearImage2(index))
                          }, [
                            _createVNode(_component_el_icon, { class: "trash-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DeleteFilled)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_26)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.fileList2.length < 5)
                    ? (_openBlock(), _createBlock(_component_el_upload, {
                        key: 0,
                        "file-list": _ctx.fileList2,
                        action: _ctx.UpdateApi,
                        "on-success": _ctx.handleAvatarSuccess2,
                        "before-upload": _ctx.beforeAvatarUpload2,
                        "show-file-list": false,
                        "list-type": "picture-card",
                        class: "slideshow-uploader"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["file-list", "action", "on-success", "before-upload"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.gameDescription')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.gameDesc,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.gameDesc) = $event)),
                  type: "textarea",
                  placeholder: "请详细描述游戏的故事背景与核心体验...",
                  size: "large",
                  rows: "6",
                  "show-word-limit": "",
                  maxlength: "400"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('edit.cover.research_characteristics')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.features,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.features) = $event)),
                  type: "textarea",
                  placeholder: "描述其独有的调研或教育探索特性...",
                  size: "large",
                  rows: "6",
                  "show-word-limit": "",
                  maxlength: "400"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"]),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("edit.cover.titleApp")), 1),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_el_icon, {
                    size: "16",
                    color: "#ffffff"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowLeft)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", _hoisted_34, [
                  _createVNode(_component_el_icon, {
                    size: "16",
                    color: "#ffffff"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_el_image, {
                  style: {"width":"100%","height":"100%"},
                  src: 
                  _ctx.form.gameCover == ''
                    ? 'https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493'
                    : _ctx.form.gameCover
                ,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.form.gameTitle == "" ? "游戏标题" : _ctx.form.gameTitle), 1),
                _createElementVNode("p", _hoisted_38, "By " + _toDisplayString(_ctx.form.author || "游戏创作者"), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("h5", _hoisted_40, _toDisplayString(_ctx.$t("edit.cover.app1")), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_el_icon, { class: "spec-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("edit.cover.app2")) + "：", 1),
                    _createVNode(_component_el_rate, {
                      modelValue: _ctx.form.difficulty,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                      disabled: "",
                      size: "small"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_el_icon, { class: "spec-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AlarmClock)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("edit.cover.app3")) + "：", 1),
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.form.playTime) + " 分钟", 1)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_el_icon, { class: "spec-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Location)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t("edit.cover.app4")) + "：", 1),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.form.placeName || "起点地点"), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("h5", _hoisted_51, _toDisplayString(_ctx.$t("edit.cover.app5")), 1),
                _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.form.gameDesc == ""
                    ? "暂无游戏介绍，请在左侧表单录入。"
                    : _ctx.form.gameDesc), 1)
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "mock-bottom-bar" }, [
                _createElementVNode("div", { class: "start-btn" }, "开启探索")
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}